import type {ReactElement} from 'react';
import React from 'react';
import {Modal} from '@Components/modal';
import {MODALS_IDS} from '@Components/modal-container';
import {LazyPanel} from '@Components/lazy-panel';
import {openPanelInModal} from '@Components/modal-container/modal-container-reducer';

const PANEL_ID = 'poster-editor-title-panel';

export default function PosterEditorTitleModal(): ReactElement<any> {
  const height = '194px';
  const maxWidth = '800px';

  return (
    <Modal
      modalId={MODALS_IDS.POSTER_EDITOR_TITLE_MODAL}
      panelId={PANEL_ID}
      mobileHeight={height}
      modalMaxWidth={maxWidth}
      isBottomSheetOnMobile
      isBottomSheetNonBlocking
      modalHeight={height}
      modalWidth="100%"
      bottomSheetCloseThreshold={100}
    >
      <LazyPanel
        panelDirectoryName="poster-editor-title-panel"
        panelProps={{
          panelId: PANEL_ID,
        }}
      />
    </Modal>
  );
}

export const openEditorTitleModal = (): void => {
  window.PMW.redux.store.dispatch(
    openPanelInModal({
      modalId: MODALS_IDS.POSTER_EDITOR_TITLE_MODAL,
      panelProps: {
        panelId: PANEL_ID,
      },
    })
  );
};
